import { MessageStatusProps, MessageStatus as Status } from "./types"
import React from "react"
import { observer } from "mobx-react-lite"
import Icon from "~widgets/icon"
import { useTheme } from '~/ui/styled'

const renderMessageStatusAsIcon = ({ message }) => {
  const theme = useTheme()
  const size = 18
  if (message.status === Status.READ && message.isReadedByOther) {
    return <Icon name={"check-3"} size={size} color={theme.colors.primary} />
  }
  switch (message.status) {
    case Status.SENDING:
      return <Icon name={"clockTimeTwoOutline"} size={size} color={theme.colors.primary} />
    case Status.SENT:
      return <Icon name={"check-1"} size={size} color={theme.colors.secondaryText} />
    case Status.DELIVERED:
      return <Icon name={"check-1"} size={size} color={theme.colors.primary} />
    case Status.READ:
      return <Icon name={"check-3"} size={size} color={theme.colors.primary} />
    case Status.FAILED:
      return <Icon name={"check-3"} size={size} color={theme.colors.primary} />
    default:
      return null
  }
}

const MessageStatus: React.FC<MessageStatusProps> = ({ message }) => {
  return renderMessageStatusAsIcon({ message })
}

export default observer(MessageStatus)
